import { http, authHeader } from '@/http-commons';

class TipoDeduccionDataService {
    lstTipoDeduccion(){
        return http.get('api/v1/tipoDeduccion/allTipoDeduccion', {headers : authHeader() });
    }
}
export default new TipoDeduccionDataService();